/**
 * Sesión del prototipo (ADR-0007): la credencial vive en sessionStorage y viaja
 * como Bearer. El servidor resuelve la organización; el cliente nunca la envía.
 */
const CLAVE = 'atalaya.credencial'
export type ModoDeIdentidad = 'credenciales' | 'chilesst'
let modo: ModoDeIdentidad | null = null

export function fijarModoDeIdentidad(nuevo: ModoDeIdentidad): void {
  modo = nuevo
  if (nuevo === 'chilesst') cerrarSesion()
}

export function credencialActual(): string | null {
  if (modo !== 'credenciales') return null
  try {
    return window.sessionStorage.getItem(CLAVE)
  } catch {
    return null
  }
}

export function guardarCredencial(token: string): void {
  if (modo !== 'credenciales') throw new Error('Las claves de organización no se usan con ChileSST.')
  window.sessionStorage.setItem(CLAVE, token)
}

export function cerrarSesion(): void {
  try {
    window.sessionStorage.removeItem(CLAVE)
  } catch {
    /* sin almacenamiento disponible */
  }
}
